(function() {
  "use strict";

  /**
   * @ngdoc object
   * @name CosmicRadiationCtrl.controller:CosmicRadiationCtrl
   *
   * @description
   *
   */
  angular
    .module("cosmicRadiation")
    .controller("CosmicRadiationCtrl", CosmicRadiationCtrl);

  function CosmicRadiationCtrl(
    applicationConstants,
    PopupManager,
    CommonLogicService,
    CommonMasterData,
    ManageFlightService,
    SearchCosmicRadiationService,
    EventManagerService,
    $scope,
    CosmicRadiationService,
    MessageService,
    ApplicationParametersService
  ) {
    var vm = this;
    vm.ctrlName = 'CosmicRadiationCtrl';
    vm.showRightPanel = false;

    vm.status = {
      CLOSE : 'CLOSE',
      SAVE : 'SAVE',
      DELETE : 'DELETE',
      NEW : 'NEW'
    };

    vm.recordAction = {
      DELETE: 'delete',
      UPDATE: 'update',
      ADD: 'create'
    }

    vm.model = {
      searchPanelToggle: true,
      editorMode: applicationConstants.EDITOR_STATUS.ADD,
      searchCriteria: {
        origin: { value: "", required: false },
        destination: { value: "", required: false },
        fromDate: {
          value: ManageFlightService.getDefaultLocation(),
          required: false
        },
        toDate: {
          value: ManageFlightService.getDefaultLocation(),
          required: false
        },
        mSvFrom: { value: "", required: false, valid: true },
        mSvTo: { value: "", required: false, valid: true }
      },
      masterList: {
        airportList: [],
        validExposure: true,
        validSearchInputs: true,
        datePickerOption: {
          minDate: null,
          maxDate: null
        }
      },
      cosmicRadiationList: CosmicRadiationService.getAllCosmicRadiation(), //grid data
      initialSearchDone: false,
      fromDateAfterToDate : false,
      selectedCosmicRadiation: null,
      deletedCosmicRadiationRecords: [],
      configData: {
        minDate:null,
        maxDate:null
      }
    };

    vm.addCosmicRadiationValue = function() {
      vm.showRightPanel = true;
    };

    vm.onCloseCosmicRadiationEdit = function() {
      vm.showRightPanel = false;
    };

    vm.onSearch = function() {
      vm.model.searchPanelToggle = false;
      SearchCosmicRadiationService.searchCosmicRadiationValues(
        vm.model.searchCriteria,
        function(){
            vm.model.cosmicRadiationList = CosmicRadiationService.getAllCosmicRadiation();
        },
        function(error){
            MessageService.error(error);
        }
      );
    };

    CommonMasterData.getAirportList(function (airportList) {
      CosmicRadiationService.setAirports(airportList);
      vm.model.masterList.airportList = CosmicRadiationService.getAirports();
    }, function (error) {})

    CosmicRadiationService.getCosmicRadiationConfig(function(configData) {
      CosmicRadiationService.setNewCosmicRadiation(configData);
      vm.model.configData.minDate = configData.periodStartDate;
      vm.model.configData.maxDate = moment(configData.periodStartDate,"DD/MM/YYYY")
        .add(configData.periodDuration, 'years').endOf('year').format("DD/MM/YYYY");
      vm.model.masterList.datePickerOption = vm.model.configData;
    }, function (error) {});

    vm.clickOnSearchCosmicRadiation = function () {
        vm.model.initialSearchDone = false;
        vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
    };

    vm.clickOnActions = function(flag) {
        if(flag.action === 'Split') {
          if(!vm.model.selectedCosmicRadiation.records[flag.index].isDisableDelete) {
            var cosmicRadiationRecords = vm.model.selectedCosmicRadiation.records;
            var newDate = cosmicRadiationRecords[flag.index].validFrom;
            var newRecord = {};

            if(compareDate(cosmicRadiationRecords[flag.index].validFrom, cosmicRadiationRecords[flag.index].validTo)===0) {
              return;
            }

            if(isDay1BeforeDay2(newDate, moment())
              && isDay1BeforeDay2(moment(), cosmicRadiationRecords[flag.index].validTo)) {
              newDate = moment();
            }

            newRecord = {
              validFrom: moment(newDate,"DD/MM/YYYY").add(1, 'days').format("DD/MM/YYYY"),
              validTo: vm.model.configData.maxDate,
              exposure: 0,
              action: vm.recordAction.ADD
            };

            cosmicRadiationRecords.splice(flag.index + 1, 0, newRecord);

            _.each(cosmicRadiationRecords, function(element, index, list) {
                if (list.length -1 !== index) {
                  newRecord = {
                    id: element.id,
                    validFrom: element.validFrom,
                    validTo: moment(list[index+1].validFrom, "DD/MM/YYYY").subtract('days', 1).format("DD/MM/YYYY"),
                    exposure: element.exposure,
                    action: element.id ? vm.recordAction.UPDATE : vm.recordAction.ADD
                  };
                  cosmicRadiationRecords.splice(index, 1, newRecord);
                }
            });
            modifySelectedData(vm.model.selectedCosmicRadiation);
          }
        }

        if(flag.action === 'Delete') {
          var param = {
            title: 'Confirmation',
            messages: ["Do you want to delete this record"]
          };

          if(!vm.model.selectedCosmicRadiation.records[flag.index].isDisableDelete) {
            PopupManager.openModal('CONFIRM_DIALOG', param, confirmDeleteDialog.bind(null, flag));
          }
        }
    };

    vm.addCosmicRadiationValue = function() {
        vm.model.deletedCosmicRadiationRecords = [];
        vm.model.editorMode =  applicationConstants.EDITOR_STATUS.ADD;
        vm.model.selectedCosmicRadiation = CosmicRadiationService.getNewCosmicRadiation();
        vm.showRightPanel = true;
    };

    vm.submitCosmicRadiation = function(event, action, selectedItem) {
        if(action === 'SAVE') {
            saveCosmicRadiation();
        } else {
            updateCosmicRadiation();
        }
    }

    vm.changeSearchField = function(event, flag, data, viewValue) {
      if (flag === "mSvFrom" || flag === "mSvTo") {
        if (data.mSvFrom.value) {
          var isValid = isExposureValid(data.mSvFrom.value);
          var isSmallerThanToValue = (!data.mSvTo.value) ? true : (parseFloat(data.mSvFrom.value) <= parseFloat(data.mSvTo.value));
          vm.model.searchCriteria.mSvFrom.valid = isValid && isSmallerThanToValue;
        } else {
          vm.model.searchCriteria.mSvFrom.valid = true;
        }

        if (data.mSvTo.value) {
          var isValid = isExposureValid(data.mSvTo.value);
          var isSmallerThanToValue = (!data.mSvFrom.value) ? true : (parseFloat(data.mSvFrom.value) <= parseFloat(data.mSvTo.value));
          vm.model.searchCriteria.mSvTo.valid = isValid && isSmallerThanToValue;
        } else {
          vm.model.searchCriteria.mSvTo.valid = true;
        }
      }


      vm.model.masterList.validSearchInputs = Object.values(vm.model.searchCriteria).every(function(e) {
        if (e.valid !== undefined) {
          return e.valid;
        } else {
          return true;
        }
      })

      console.log(vm.model.masterList.validSearchInputs);
      if(flag == "matchingIndex") {
        setMatchingIndexForAirports(viewValue);
      }
      return;
    }

    function setMatchingIndexForAirports(viewValue){
      if(viewValue !== " ") {
        angular.forEach(vm.model.masterList.airportList, function(apt) {
          apt.matchingIndex = apt.airPortCode.toLowerCase().indexOf(viewValue.toLowerCase());
        })
      }
    }

    vm.changeEditorField = function(value, flag, index, selectedItems) {

        if (flag === 'exposure') {
          var records = vm.model.selectedCosmicRadiation.records;

          vm.model.masterList.validExposure = vm.model.selectedCosmicRadiation.records.every(function(e) {
            console.log(e.exposure)
            return (e.exposure !== undefined && isExposureValid(e.exposure));
          });

          console.log(vm.model.masterList.validExposure)

          return;
        }

        if (flag === "validFrom") {
          var records = vm.model.selectedCosmicRadiation.records;
          var currentElement = records[index];

          var validFrom = currentElement.validFrom;
          var validTo = currentElement.validTo;
          var newRecord = {};

          if (index > 0 && index < records.length -1 && compareDate(records[index+1].validFrom, validFrom) <= 0){
            console.log('This case');
            newRecord = {
              id: currentElement.id,
              action: vm.recordAction.UPDATE,
              validFrom: moment(records[index-1].validTo, "DD/MM/YYYY").add(1, 'days').format("DD/MM/YYYY"),
              validTo: validTo,
              exposure: 0
            };
            records.splice(index, 1, newRecord);

            return;
          }

          if(index === 0) {
            if(compareDate(validFrom, validTo) > 0) {
              newRecord = {
                id: currentElement.id,
                action: vm.recordAction.UPDATE,
                validFrom: vm.model.configData.minDate,
                validTo: validTo,
                exposure: 0
              };

              records.splice(index, 1, newRecord);
            } else {
              newRecord = {
                validFrom: vm.model.configData.minDate,
                action: vm.recordAction.ADD,
                validTo: moment(validFrom, "DD/MM/YYYY").subtract('days', 1).format("DD/MM/YYYY"),
                exposure: 0
              };

              records.splice(index, 0, newRecord);
            }
          } else {

            if(compareDate(validTo, validFrom)<0) {
              records.splice(index, 1);
            }

            for (var j = index-1; j >= 0; j--) {
              var prevElement = records[j];
              var currentElement = records[j+1];

              if (compareDate(prevElement.validFrom, validFrom) >= 0){
                records.splice(j, 1);
              } else if (compareDate(prevElement.validTo, validFrom) >= 0 || compareDate(prevElement.validTo, moment(validFrom, "DD/MM/YYYY").subtract('days', 1).format("DD/MM/YYYY")) < 0){
                newRecord = {
                  id: prevElement.id,
                  action: vm.recordAction.UPDATE,
                  validFrom: moment(prevElement.validFrom, "DD/MM/YYYY").format("DD/MM/YYYY"),
                  validTo: moment(currentElement.validFrom, "DD/MM/YYYY").subtract('days', 1).format("DD/MM/YYYY"),
                  exposure: 0
                };
                records.splice(j, 1, newRecord);
              } else {
                return;
              }
            }
          }
          modifySelectedData(vm.model.selectedCosmicRadiation);
        }

        if (flag === "validTo") {
          var records = vm.model.selectedCosmicRadiation.records;
          var currentEelement = records[index];

          var validFrom = currentEelement.validFrom;
          var validTo = currentEelement.validTo;

          var nextValidFrom = moment(currentEelement.validTo,"DD/MM/YYYY").add(1, 'days').format("DD/MM/YYYY");
          var nextValidTo = records.length - 1 !== index && vm.model.selectedCosmicRadiation.records[index+ 1].validTo;
          var nextId = records.length - 1 !== index && vm.model.selectedCosmicRadiation.records[index+ 1].id;

          if(compareDate(nextValidFrom, nextValidTo) >=0 && compareDate(nextValidTo, vm.model.configData.maxDate)<0){
            var nextValidTo = moment(nextValidFrom,"DD/MM/YYYY").add(1, 'days').format("DD/MM/YYYY");

            var nextRecord = {
              id: nextId,
              action: vm.recordAction.UPDATE,
              validFrom: nextValidFrom,
              validTo: nextValidTo,
              exposure: 0
            };

            records.splice(index + 1, 1, nextRecord);
          }

          if (records.length - 1 === index) {
            var updatedRecord = {
              id: currentEelement.id,
              action: vm.recordAction.UPDATE,
              validFrom: validFrom,
              validTo: vm.model.configData.maxDate,
              exposure: 0
            };
            records.splice(index, 1, updatedRecord);
          }

          _.each(records, function(element, index, list) {
            if (index>0) {
              var newRecord = {
                id: element.id,
                action: vm.recordAction.UPDATE,
                validFrom: moment(list[index-1].validTo, "DD/MM/YYYY").add(1, 'days').format("DD/MM/YYYY"),
                validTo: element.validTo,
                exposure: element.exposure
              };
              records.splice(index, 1, newRecord);
            }

            if(moment(element.validTo, "DD/MM/YYYY").diff(moment(element.validFrom, "DD/MM/YYYY"))<0){
              var newRecord = {
                id: element.id,
                action: vm.recordAction.UPDATE,
                validFrom: element.validFrom,
                validTo: element.validFrom,
                exposure: element.exposure
              };
              records.splice(index, 1, newRecord);
            }
          });
          modifySelectedData(vm.model.selectedCosmicRadiation);
        }

        if(flag === "CANCEL") {
            vm.onCloseCosmicRadiationEdit();
        }
    };

    vm.onCloseCosmicRadiationEdit = function() {
        vm.model.selectedCosmicRadiation = CosmicRadiationService.getNewCosmicRadiation();
        vm.showRightPanel = false;
    };

    vm.selectCosmicRadiation = function(selectedRowData) {
        vm.model.deletedCosmicRadiationRecords = [];
        vm.model.editorMode =  applicationConstants.EDITOR_STATUS.EDIT;
        modifySelectedData(selectedRowData);
        vm.model.selectedCosmicRadiation = angular.copy(selectedRowData);
        vm.showRightPanel = true;
    };

    function compareDate(dateTimeA, dateTimeB) {
      var momentA = moment(dateTimeA,"DD/MM/YYYY");
      var momentB = moment(dateTimeB,"DD/MM/YYYY");
      if (momentA > momentB) return 1;
      else if (momentA < momentB) return -1;
      else return 0;
    }

    function saveCosmicRadiation() {
        _.each(vm.model.selectedCosmicRadiation.records, function(element) {
          element.action = vm.recordAction.ADD;
        });

        CosmicRadiationService.createCosmicRadiation(vm.model.selectedCosmicRadiation,
            function (response) {
                vm.model.searchCriteria.origin.value = vm.model.selectedCosmicRadiation.origin;
                vm.model.searchCriteria.destination.value = vm.model.selectedCosmicRadiation.destination;
                vm.onSearch();
                vm.onCloseCosmicRadiationEdit();
            }, function (error) {
              console.log('Error save cosmic radiation', error);
            }
        );
    }

    function updateCosmicRadiation() {
      _.each(vm.model.selectedCosmicRadiation.records, function(element) {
          if(!element.action) {
            element.action = vm.recordAction.UPDATE;
          }

          if(!element.id) {
            element.action = vm.recordAction.ADD;
          }
      });

      if(vm.model.deletedCosmicRadiationRecords.length > 0) {
        var records = collectionUnion(vm.model.selectedCosmicRadiation.records,
          vm.model.deletedCosmicRadiationRecords, function (item) {
            return item;
        });
      }

      var records = records ? records : vm.model.selectedCosmicRadiation.records

      CosmicRadiationService.updateCosmicRadiation(vm.model.selectedCosmicRadiation, records,
        function (response) {
            vm.model.searchCriteria.origin.value = {airPortCode: vm.model.selectedCosmicRadiation.origin};
            vm.model.searchCriteria.destination.value = {airPortCode: vm.model.selectedCosmicRadiation.destination};
            vm.onSearch();
            vm.onCloseCosmicRadiationEdit();
        }, function (error) {
          console.log('Error save cosmic radiation', error);
        }
      );
    }

    function deletedRecords (item) {
      var delitedRecords = vm.model.deletedCosmicRadiationRecords;
      var removedObject = item[0];
      if ( removedObject.hasOwnProperty('id') && removedObject.id) {
        removedObject.action = vm.recordAction.DELETE
        delitedRecords.push(removedObject);
      }
    }

    function confirmDeleteDialog(flag, pass) {
      if(pass==='YES') {
        deletedExposureFromRow(flag);
      }
    }

    function deletedExposureFromRow (flag) {
      var cosmicRadiation = vm.model.selectedCosmicRadiation;
      var newRecord = {};

      if(flag.index === 0) {
        newRecord = {
          id: cosmicRadiation.records[flag.index + 1].id,
          action: cosmicRadiation.records[flag.index + 1].id ? vm.recordAction.UPDATE : vm.recordAction.ADD,
          validFrom: cosmicRadiation.records[flag.index].validFrom,
          validTo: cosmicRadiation.records[flag.index + 1].validTo,
          exposure: cosmicRadiation.records[flag.index + 1].exposure
        };

        cosmicRadiation.records.splice(flag.index+1, 1, newRecord);
      } else {
        newRecord = {
          id: cosmicRadiation.records[flag.index - 1].id,
          action: cosmicRadiation.records[flag.index - 1].id ? vm.recordAction.UPDATE : vm.recordAction.ADD,
          validFrom: cosmicRadiation.records[flag.index - 1].validFrom,
          validTo: cosmicRadiation.records[flag.index].validTo,
          exposure: cosmicRadiation.records[flag.index - 1].exposure
        };
        cosmicRadiation.records.splice(flag.index-1, 1, newRecord);
      }

      var removed = cosmicRadiation.records.splice(flag.index, 1);
      deletedRecords(removed);
    }

    function isDateFormatInvalid(date) {
			if (!!date && !moment(date, "DD/MM/YYYY").isValid()) {
				return true;
			}
			return false;
    }

    function isDay1BeforeDay2(day1, day2) {
      return moment(day1, "DD/MM/YYYY").isBefore(
        moment(day2, "DD/MM/YYYY"));
    }

    function isExposureValid(value) {
      return value.toString().match(/^\d*(\.\d+)?$/) && parseFloat(value) >= 0 && parseFloat(value) <= 10;
    }

    function setDateValidationFlags() {
      if (!isDateFormatInvalid(vm.modelSlotMessageSearch.searchCriteria.fromDateStr)
        && !isDateFormatInvalid(vm.modelSlotMessageSearch.searchCriteria.toDateStr)) {
        vm.modelSlotMessageSearch.fromDateAfterToDate = isDay1BeforeDay2(
          vm.modelSlotMessageSearch.searchCriteria.toDateStr,
          vm.modelSlotMessageSearch.searchCriteria.fromDateStr);
      } else {
        vm.modelSlotMessageSearch.fromDateAfterToDate = false;
      }
    }

    function collectionUnion() {
      var args = Array.prototype.slice.call(arguments);
      var it = args.pop();

      return _.uniq(_.flatten(args, true), it);
    }

    function modifySelectedData(selectedData) {
      return selectedData.records.map(function(record) {
        record.isDisableDelete = !isDay1BeforeDay2(moment(), record.validTo);
        return record
      });
    }
  }
})();
